module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"status":"Статус","type":"Тип платежа","itemType":"Тип услуги","id":"Номер счета","date":"Дата","amount":"Сумма списания","noPayments":"Нет прошедших оплат","tariff":"Тариф"}}')
  delete Component.options._Ctor
}
